export default {
  // 数据分析
  data_analysis: {
    viewdata: 'View data',
    adapterDevice: 'Adapter device',
    exit: 'Exit',
    fullScreen: 'Full screen',
    preview: 'Preview',
    today: 'Today',
    update: 'Update',
    chartNoDate: 'Charts without data',
    addChart: 'Add the chart',
    fenpeiShare: 'Distribution of Shared',
    allFilter: 'Global filtering',
    cilckCancelLinkage: 'Click cancel linkage',
    allFilterSet: 'Global filter Settings',
    screen: 'Screen',
    chartLinkageSet: 'Chart linkage setting',
    timeUpdateSet: 'Timed refresh setting',
    copyChart: 'Copy chart',
    editChart: 'Edit diagrams',
    chartLinkage: 'Chart linkage ',
    timeUpdate: 'Time to refresh',
    personnel: 'Personnel',
    minAddOneChart: 'Please add at least one chart',
    dataChangeIfSave: 'Does the data change and need to be saved?',
    saveOkReturn: 'Saved successfully, returning...',
    shareToMe: 'Share it with me',
    addReport: 'New data analysis',
    noNameChart: 'Unnamed chart',
    dataIsNormal: 'The data is normal',
    time: 'Time',
    statistical: 'Statistics',
    dimension: 'Dimensionality',
    editShowName: 'Modify display name',
    dimensionColumn: 'Dimension (column)',
    value: 'Value',
    editFiledName: 'Change the field name',
    subtotal: 'Subtotal',
    total: 'Total',
    sum: 'Summation',
    average: 'Average',
    min: 'Minimum ',
    max: 'Maximum',
    count: 'Count',
    repeatCount: 'Weight loss count',
    dataFormat: 'Data format',
    useYear: 'Per annually',
    useHalfYear: 'Semi-annually',
    useQuarter: 'Quarterly',
    useMounth: 'Monthly',
    useWeek: 'Weekly',
    useDay: 'Per diem',
    useDepartment: 'According to the department',
    usePersonnel: 'Per capita',
    sort: 'Sort',
    default: 'Default',
    asc: 'Ascending order',
    desc: 'Descending order',
    alignment: 'Alignment',
    left: 'JustifyLeft',
    center: 'Center',
    chartName: 'Graph Name',
    right: 'JustifyRight',
    show: 'Show',
    chartType: 'Chart type',
    assistSet: 'Auxiliary Settings',
    align: 'Align',
    remarkColor: 'Marker color',
    warningSet: 'Warning setting',
    numberOfEntries: 'Number of entries',
    showTiaoshu: 'PageNum',
    pageSet: 'Page setup',
    tableSet: 'Table Settings',
    chartSet: 'Legend set',
    showSet: 'Display settings',
    showTag: 'Display labels',
    showValue: 'Display values',
    showPercent: 'Show percent',
    chartScreenSet: 'Graph filter Settings',
    range: 'Range',
    targetValue: 'Target value',
    addOption: 'Add item',
    filterSet: 'Filter condition setting',
    highCondition: 'Advanced conditions',
    addScreenCondition: 'Add filter criteria',
    juLeft: 'Left',
    juRight: 'Right',
    top: 'Top',
    bottom: 'Bottom',
    customerLevel: 'Client grade',
    principal: 'Principal',
    before: 'Before',
    after: 'After',
    targetValueAfterMax: 'The value after the target value must be greater than the previous value',
    max8Option: 'You can add a maximum of eight items',
    dataSource: 'Data source',
    moveUnderFieldToValue: 'Drag the following fields into the dimension/value',
    field: 'Field',
    addField: 'Add fields',
    sureDelField: 'Are you sure you want to delete this field?',
    fieldNameMust: 'Field names are required',
    themeStyle: 'The theme style',
    pureColor: 'Pure color ',
    picture: 'Picture',
    custom: 'Custom',
    chartColor: 'The chart color',
    borderSet: 'Border Settings',
    color: 'Color',
    borderType: 'Line type',
    borderWidth: 'Line width',
    white: 'White',
    grey: 'Grey',
    blue: 'Blue',
    yellow: 'Yellow',
    black: 'Black',
    purple: 'Purple',
    pleaseAddFormula: 'Please add the formula',
    operator: 'Operator',
    returnType: 'Return type',
    decimalDigits: 'Decimal digits',
    precision: 'Precision',
    dayu: 'Greater than',
    xiaoyu: 'Less than',
    dengyu: 'Equal to',
    budengu: 'Unequal to',
    dayudengyu: 'Be equal or greater than',
    xiaoyudengyu: 'Less than or equal to',
    weikong: 'Null',
    buweikong: 'Not null',
    number: 'Number',
    integer: 'Integer',
    percent: 'Percentage',
    rounded: 'Round',
    quweifa: 'Rounding Down',
    jinyifa: 'Ceil',
    noFengefu: 'No delimiters',
    qianFengefu: 'Thousandth separator',
    wanFengefu: 'Ten-thousandth separator',
    sameDataSource: 'For the same data source, no linkage fields need to be set',
    setMainLinkage: 'Set the fields associated with the main chart',
    guanlianFieldNotEmpty: 'The correlation field cannot be empty',
    selectedField: 'The selected field',
    addField1: 'Added field',
    contion: 'Condition',
    screenContion: 'Screening condition',
    showColor: 'Show colors',
    pleaseInputName: 'Please enter the name',
    refreshRate: 'Refresh rate',
    enter5Interger: 'Please enter an integer greater than 5',
    seconds: 'Second',
    minute: 'Minute',
    hour: 'Hour',
    selectChartDataSource: 'Select the chart data source',
    qiehuanClear: 'Switching the data source clears all Settings for the chart',
    sureQiehuan: 'Are you sure you want to switch?',
    yes: 'Yes',
    no: 'No',
    highlight: 'Highlight',
    contionSetError: 'Condition setting is wrong',
    screenOption: 'Ccreening items',
    selectScreenChart: 'Select the chart you want to filter',
    selectScreenField: 'Select the fields as filter items',
    zhishaoSelectOneChart: 'Select the fields as filter items',
    haveFilterEmpty: 'There is an empty filter field',
    nameNotRepeat: 'Names are not allowed to be repeated',
    enterDsign: 'Enter design',
    multiChartCalculation: 'Multi chart calculation',
    chartNumber: 'Graph - digital graph',
    leftAddFormula: 'Please add a formula field from the number chart on the left',
    showChartType: 'Show chart type',
    chartNameMustFill: 'Chart name is required',
    tongbiHuanbi: 'Compared with the sequential',
    tongbi: 'Year on year',
    huanbi: 'Link relative ratio',
    huanbiUpValue: 'Sequential growth',
    huanbiUpLv: 'Sequential growth rate',
    lastWeekTBValue: 'Year-over-year last week',
    lastWeekTBLv: "Last week's same rate",
    lastMonthTBValue: 'Year-over-month value last month',
    lastMonthTBLv: "Last month's same rate",
    lastYearTBValue: 'Year-over-year value',
    lastYearTBLv: 'Year-over-year rate',
    showChartCount: 'Show intra-map statistics',
    analysisFormulaTip1: 'Only numeric and date components can be added to a function',
    analysisFormulaTip2: 'Only numeric components can be added to a function',
    chooseRequiredAnd: 'Please select Needs and',
    linkageChart: 'Linked Charts',
    DimensionRequired: 'Dimension is required',
    startTimeRequired: 'Start time is required',
    endTimeRequired: 'End time is required',
    DimensionValueNotValue: 'Dimension and value cannot be empty at the same time',
    progress: 'Speed of progress',
    listFields: 'List fields',
    dontDragExistingField: 'You cannot drag in an existing field',
    dragTimeCompent: 'Please drag in the time component',
    dragValeCompent: 'Please drag in the digital component',
    GanttMaxDimension: 'The dimension field of Gantt chart cannot be more than three',
    Timescale: 'Timescale',
    chartDisplaySetting: 'Graphic display field settings',
    quarter: 'Quarter',
    FirstQuarter: 'First quarter',
    SecondQuarter: 'Second quarter',
    ThirdQuarter: 'Third quarter',
    FourthQuarter: 'Fourth quarter',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    theTimeScale: 'The time scale',

    // 2021-03-15
    ganttTimeTips:
      'The end time must be greater than the start time, otherwise the chart will be empty',
    // 2024-05-20
    chartScreen: 'Graph filtering',
    linkage: 'Linkage',
    viewSourceData: 'View raw data',
    addKanban: 'Add bulletin board',
    group: 'Group',
    searchReportDesc: 'Search for reports and report descriptions',
    dataUpdataBy: 'Update data to',
    kanbanName: 'Bulletin board name',
    fromGroup: 'Owning group',
    tips: 'Warm reminder',
    addGroup_tips1: 'Drag groups up and down to sort them, and click Edit names',
    addGroup_tips2: 'Groups with kanban cannot be deleted',
    groupKanban: 'Intra-group bulletin board',
    sourDelGroup: 'Are you sure you want to delete the group?',
    kanbanNameMust: 'Bulletin board name is required',
    groupNameMust: 'Owning group This parameter is mandatory',
    layoutContainer: 'Layout container',
    appearanceSetting: 'Appearance setting',
    ApplyTemplate: 'Apply template',
    width: 'Width',
    height: 'Height',
    column: 'Column',
    cell: 'Cell',
    editKanban: 'Editorial bulletin board',
    growthValue: 'Growth value',
    growthRate: 'Rate of increase',
    contraRatio: 'Contra-ratio',
    nonameLayout: 'Unnamed layout container',
    noSelectSource: 'Data source not selected',
    chartStyle: 'Chart style',
    dashboardStyle: 'Dashboard style',
    styleSetTips1: 'Please select the chart on the left to set up',
    styleSetTips2: 'Select chart Settings in batches by holding down Ctrl/Command+ mouse click',
    showTitle: 'Display title',
    layoutName: 'Layout name',
    layoutStyle: 'Layout style',
    backgroundOpacity: 'Background transparency',
    titleAlign: 'Title alignment',
    chartInnerFont: 'Inner font',
    showBorder: 'Display border',
    allDefaultColor: 'Default overall color scheme',
    thisBatchSet: 'This setting is for batch modification and cannot be restored after clicking',
    dashboardAllset: 'Integral instrument panel',
    allBackground: 'Overall background',
    allChartsStyle: 'Chart style',
    titleBckground: 'Title background',
    colorPlan: 'Color scheme',
    gradation: 'Gradation',
    tableTypeCharts: 'Tabular chart',
    chartMainColor: 'Chart dominant color',
    titleFontColor: 'Header text',
    contentText: 'Content text',
    point: 'Point',
    colorSetOptions1: 'Default color',
    colorSetOptions2: 'Classic color matching',
    colorSetOptions3: 'Elegant Style',
    colorSetOptions4: 'Party Affairs/Educational Affairs',
    colorSetOptions5: 'Warm tone',
    colorSetOptions6: 'Trend Green purple',
    colorSetOptions7: 'Smart Commerce',
    colorSetOptions8: 'Smart Finance',
    colorSetOptions9: 'Technology Business',
    colorSetOptions10: 'Sky',
    colorSetOptions11: 'Passion',
    colorSetOptions12: 'Fresh',
    colorSetOptions13: 'Sunlight',
    colorSetOptions14: 'Mystery',
    colorSetOptions15: 'Lemon',
    colorSetOptions16: 'Aurora',
    functionConfig: 'Function configuration',
    dateField: 'Date field',
    valueSet: 'Value setting',
    selectDate: 'Selected date',
    sourceData: 'Source Data',
    layoutSelect: 'Layout selection',
    valueCardSize: 'value card size',
    miniCard: 'Small indicator card',
    maxCard: 'Big indicator card',
    iconLocation: 'Icon location',
    iconColor: 'Icon Color',
    sideStrip: 'Side strip',
    mapColor: 'Map Color',
    valueAlign: 'Align values',
    themeColor: 'Theme color',
    lastWeekTb: 'Last week year-on-year',
    lastMonthTb: 'Last month year-on-year',
    lastYearTb: 'Year-on-year last year'
  }
}
